module.exports = __webpack_public_path__ + "img/youtubenew.8f401406.svg";